const session = (state = [], action) => {
    switch (action.type) {
        case 'SET_USER':
            if (state.find(x => x.type === action.type)) {
                return state.map(session =>
                    (session.type === action.type)
                    ? { ...session, user: action.user }
                    : session
                );
            }
            else {
                return [
                    ...state,
                    {
                        type: action.type,
                        user: action.user
                    }
                ];
            }
        default:
            return state;
    }
};

export default session;